import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { registerItemKeys } from '../registerItemKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  IRegisterItemAttachmentsResult,
  RegisterItemAttachmentsResult,
} from '@core/entities/register/RegisterItemAttachment'

const transformer = (
  data: IRegisterItemAttachmentsResult,
): RegisterItemAttachmentsResult => RegisterItemAttachmentsResult.new(data)

export const useGetRegisterItemAttachments = (
  payload: RequestTypes['getRegisterItemAttachments'],
  options?: UseQueryOptions<
    IRegisterItemAttachmentsResult,
    RequestErrorType,
    RegisterItemAttachmentsResult
  >,
) => {
  const attachmentsQuery = registerItemKeys
    .byId(payload)
    ._ctx.attachments(payload)

  return useQuery({
    select: transformer,
    ...attachmentsQuery,
    ...options,
  })
}
